// Shared inner body for the Oscar account wish-list delete-confirmation page.
// Renders inside AccountPageBody (the account side-nav shell) without the
// document chrome -- each site wraps this in its own PageSkeleton so the DOM is
// byte-identical to the pre-move AccountPageShell.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountPageBody } from "../AccountPageBody";

type IProps = Immutable<templates.WishListDeleteDocumentTemplate>;

export const WishListDeleteBody = (props: IProps): React.JSX.Element => {
    const {
        action_url,
        confirm_message,
        delete_label,
        deleting_label,
        or_label,
        cancel_label,
        cancel_url,
    } = props;
    return (
        <AccountPageBody sideNav={props.side_nav}>
            <form method="post" action={action_url}>
                <CSRFToken />
                <p>{confirm_message}</p>

                <div className="form-group">
                    <button
                        type="submit"
                        className="btn btn-danger btn-lg"
                        data-loading-text={deleting_label}
                    >
                        {delete_label}
                    </button>{" "}
                    {or_label} <a href={cancel_url}>{cancel_label}</a>
                </div>
            </form>
        </AccountPageBody>
    );
};
